module.exports = __webpack_public_path__ + "static/media/510.f23dc681.webp";